<div class="container-fluid" *ngIf="f">
  <div *ngIf="isModalOpen" style="padding: 20px;" class="d-flex modal_heading justify-content-between">
    <div class="f-20 fw-600" style="width: 100%; margin-right: 10px">
      Edit License
    </div>
    <div>
      <img
        src="assets\images\closeIcon.svg"
        style="cursor: pointer"
        (click)="closeModal2()"
      />
    </div>
  </div>
    <form [formGroup]="licenseForm">
        <div class="card" style="margin-bottom: 70px !important;">
            <div class="card-body">
                <div class="row">
                    <div [ngClass]="{'col-lg-12': isModalOpen, 'col-lg-7': !isModalOpen}">
                        <div *ngIf="!isModalOpen" class="row mb-3">
                            <div class="col-sm-5 mt-2">
                                <label for="input1" class="form-label">Expiration Date*<img
                                        src="assets\images\!.png"></label>
                            </div>
                            <div class="col-sm-7">
                                <input type="date" class="form-control" id="input1" placeholder="Expiration Date"
                                formControlName="expirationDate" (change)="changeUpdate($event)">
                                <div
                                class="form-text text-danger"
                                *ngIf="
                                  f.get('expirationDate').errors?.required &&
                                  (f.get('expirationDate').touched || submitted)
                                "
                              >
                                Please provide a expiration date.
                              </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-5 mt-2">
                                <label for="input2" class="form-label">Employee Limit*<img
                                        src="assets\images\!.png"></label>
                            </div>
                            <div class="col-sm-7">
                                <input type="number" class="form-control" id="input2" placeholder="Employee Limit"
                                formControlName="employeeLimit" (keyup)="changeUpdate($event)">
                                <div
                                class="form-text text-danger"
                                *ngIf="
                                  f.get('employeeLimit').errors?.required &&
                                  (f.get('employeeLimit').touched || submitted)
                                "
                              >
                                Please provide a employee limit.
                              </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-5 mt-2">
                                <label for="input3" class="form-label">Account Limit*<img
                                        src="assets\images\!.png"></label>
                            </div>
                            <div class="col-sm-7">
                                <input type="number" class="form-control" id="input3" placeholder="Account Limit"
                                formControlName="accountLimit" (keyup)="changeUpdate($event)">
                                <div
                                class="form-text text-danger"
                                *ngIf="
                                  f.get('accountLimit').errors?.required &&
                                  (f.get('accountLimit').touched || submitted)
                                "
                              >
                                Please provide a account limit.
                              </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-5 mt-2">
                                <label for="input4" class="form-label">QSR Limit*<img
                                        src="assets\images\!.png"></label>
                            </div>
                            <div class="col-sm-7">
                                <input type="number" class="form-control" id="input4" placeholder="QSR Limit"
                                formControlName="qsrLimit" (keyup)="changeUpdate($event)">
                                <div
                                class="form-text text-danger"
                                *ngIf="
                                  f.get('qsrLimit').errors?.required &&
                                  (f.get('qsrLimit').touched || submitted)
                                "
                              >
                                Please provide a QSR limit.
                              </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-5 mt-2">
                                <label for="input5" class="form-label">KDS Limit*<img
                                        src="assets\images\!.png"></label>
                            </div>
                            <div class="col-sm-7">
                                <input type="number" class="form-control" id="input5" placeholder="KDS Limit"
                                formControlName="kdsLimit" (keyup)="changeUpdate($event)">
                                <div
                                class="form-text text-danger"
                                *ngIf="
                                  f.get('kdsLimit').errors?.required &&
                                  (f.get('kdsLimit').touched || submitted)
                                "
                              >
                                Please provide a KDS limit.
                              </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-5 mt-2">
                                <label for="input6" class="form-label">Kiosk Limit*<img
                                        src="assets\images\!.png"></label>
                            </div>
                            <div class="col-sm-7">
                                <input type="number" class="form-control" id="input6" placeholder="Kiosk Limit"
                                formControlName="kioskLimit" (keyup)="changeUpdate($event)">
                                <div
                                class="form-text text-danger"
                                *ngIf="
                                  f.get('kioskLimit').errors?.required &&
                                  (f.get('kioskLimit').touched || submitted)
                                "
                              >
                                Please provide a Kiosk limit.
                              </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-5 mt-2">
                                <label for="input7" class="form-label">Full Limit*<img
                                        src="assets\images\!.png"></label>
                            </div>
                            <div class="col-sm-7">
                                <input type="number" class="form-control" id="input7" placeholder="Full Limit"
                                formControlName="fullLimit" (keyup)="changeUpdate($event)">
                                <div
                                class="form-text text-danger"
                                *ngIf="
                                  f.get('fullLimit').errors?.required &&
                                  (f.get('fullLimit').touched || submitted)
                                "
                              >
                                Please provide a full limit.
                              </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-5 mt-2">
                              <label for="input8" class="form-label">Price*<img
                                      src="assets\images\!.png"></label>
                          </div>
                          <div class="col-sm-7">
                              <input type="number" class="form-control" id="input8" placeholder="Price"
                              formControlName="price" (keyup)="changeUpdate($event)">
                              <div
                              class="form-text text-danger"
                              *ngIf="
                                f.get('price').errors?.required &&
                                (f.get('price').touched || submitted)
                              "
                            >
                              Please provide a price.
                            </div>
                          </div>
                      </div>


                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<ng-template #copyClipboard role="document" let-modal>
  <div class="modal-header border-0">
    <h1></h1>
    <button
      type="button"
      class="btn-close"
      aria-hidden="true"
      (click)="closeCopy()"
    ></button>
  </div>
  <div class="modal-body border-0 text-center">
    <h6>Lisense key: {{licensedKey}}</h6>
  </div>
  <div class="modal-footer border-0">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 text-center">
          <button
            class="btn btn-dark fw-bold add-btn"
            (click)="copylicense()"
          >
           Copy License
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
